import React, { useState } from "react";
import { useForm } from "react-hook-form";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import DatePickerInput from "../../share/input/DatePicker";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../share/buttons/Btn";
import Inputs from "../../share/input/Inputs";
import { ReactComponent as Upload } from "../../../Assets/Image/svg/Upload.svg";
import { AiOutlinePlus, AiOutlineMinus } from "react-icons/ai";
import IconButton from "../../share/buttons/IconButton";

function TicketModal({ close }) {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);
  const [num, setNem] = useState(0);
  return (
    <div className="AddnewsupportTicket relative">
      <button
        onClick={() => close(false)}
        className="AddnewsupportTicket-cancel absolute  "
      >
        <div>
          <Cancel />
        </div>
      </button>
      <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
        اطلاعات بلیت
      </h3>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="flex flex-col justify-center"
      >
        <Inputs
          register={{
            required: {
              value: true,
              message: "نام بلیت را وارد کنید",
            },
          }}
          type="text"
          name="name"
          control={control}
          placeholder="نام بلیت *"
          className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
        />
        <div className="flex justify-around gap-8 mb-[1.6rem]">
          <Inputs
            register={{
              required: {
                value: true,
                message: "نام بلیت را وارد کنید",
              },
            }}
            type="number"
            name="name"
            control={control}
            placeholder="قیمت بلیت *"
            full={true}
            className="border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
          />
          <div className="flex items-center justify-center w-full">
            <IconButton
              className="px-[1rem] py-[0.9rem] rounded-r-[1.5rem] bg-purple hover:bg-purple-dark"
              text="اضافه کردن تعداد"
              type="button"
              onClick={() => setNem(num + 1)}
            >
              <AiOutlinePlus className=" text-[1.6rem] text-[#fff] " />
            </IconButton>
            <Inputs
              register={{
                required: {
                  value: true,
                  message: "choose a number",
                },
              }}
              type="number"
              name="company_name"
              control={control}
              full={true}
              className="border-[#21212182] border-[1px] border-solid text-center bg-[#F2F3F5] text-[1.6rem] text-[#212121E5] placeholder:text-[#212121E5] focus:outline-none"
              placeholder="تعداد بلیت"
              value={num}
            />
            <IconButton
              className="px-[1rem] py-[0.9rem] rounded-l-[1.5rem] bg-black-prim opacity-[51%] hover:bg-black-prim hover:opacity-[71%]"
              text="کم کردن تعداد"
              type="button"
              onClick={() => num > 0 && setNem(num - 1)}
            >
              <AiOutlineMinus className=" text-[1.6rem] text-[#fff] " />
            </IconButton>
            {/* <p className=" mr-[1rem] text-[1.4rem] leading-[2.4rem]">
                    نفر
                </p> */}
          </div>
        </div>
        <div className="flex justify-around gap-8 mb-[1.6rem]">
          <DatePickerInput
            register={{
              required: true,
            }}
            message="تاریخ را وارد کنید"
            placeholder="تاریخ را وارد کنید"
            name="catch_end_date"
            control={control}
            full={true}
            format="MM/DD/YYYY HH:mm:ss"
            plugins={[<TimePicker position="bottom" />]}
          />
          <DatePickerInput
            register={{
              required: true,
            }}
            message="تاریخ را وارد کنید"
            placeholder="تاریخ را وارد کنید"
            name="catch_end_date"
            control={control}
            full={true}
            format="MM/DD/YYYY HH:mm:ss"
            plugins={[<TimePicker position="bottom" />]}
          />
        </div>
        <div className="flex gap-48 self-end">
          <BtnPrimary
            className=" py-[20px] px-[81px] mr-auto"
            text="ثبت بلیت"
          />
        </div>
      </form>
    </div>
  );
}

export default TicketModal;
